const enum HeaderType {
  Name,
  Memo,
  Time,
  LastDetectedDevice,
  BatteryLifeRessetedAt,
  Status,
}

export default HeaderType
